import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { ReadStateOrDefault } from "source/app/services/UI/State/ReadState";
import {
    ShareState,
    SubscribeToSharedState,
} from "../../../../services/UI/State/ShareState";
import { LoadQuickJournalStoredSnapshotFromLocalStorage, ShouldWipeQuickJournalData, WipeQuickJournalDataAsync } from "../Data/Entries/QuickJournalEntryStorage";
import { BuildQuickJournalStoredSnapshot } from "../Data/Stats/QuickJournalStatsCore";
import { useQuickJournalSystemClockVersion } from "./useQuickJournalSystemClockVersion";
import { IQuickJournalState } from "../Data/QuickJournalTypes";

export function useQuickJournalSharedState() {
    const shouldWipeQuickJournalData = ShouldWipeQuickJournalData();
    const didApplyWipeRef = React.useRef(false);
    const initialSnapshot = shouldWipeQuickJournalData
        ? BuildQuickJournalStoredSnapshot([])
        : LoadQuickJournalStoredSnapshotFromLocalStorage();
    const [state, setState] = React.useState<IQuickJournalState>({
        draft: "",
        recentEntries: initialSnapshot.recentEntries,
        weeklyHourlyCounts: initialSnapshot.weeklyHourlyCounts,
        horizontalOffset: 0,
        animatingEntryCreatedAt: [],
    });
    const [useAnopenscrollFont, setUseAnopenscrollFont] = React.useState(
        ReadStateOrDefault(
            ESharedFunction.FontSwitcher_useAnopenscrollFont,
            false
        )
    );

    useQuickJournalSystemClockVersion();
    SubscribeToSharedState<boolean>(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        setUseAnopenscrollFont
    );

    ShareState(ESharedFunction.TypeAwayInputBox_state, state, setState);

    React.useEffect(() => {
        if (!shouldWipeQuickJournalData || didApplyWipeRef.current) {
            return;
        }

        didApplyWipeRef.current = true;
        void WipeQuickJournalDataAsync();
        setState((currentState) => ({
            ...currentState,
            draft: "",
            recentEntries: [],
            weeklyHourlyCounts: {},
            animatingEntryCreatedAt: [],
        }));
    }, [shouldWipeQuickJournalData]);

    return {
        state,
        setState,
        shouldWipeQuickJournalData,
        useAnopenscrollFont,
    };
}
